import { computed, Injectable, signal } from '@angular/core';
import { SelectedTransportItem } from '@myarvato/modules/transport/models';

@Injectable({
  providedIn: 'root',
})
export class TrackingDetailsStore {
  private readonly _selectTrackingItem = signal<SelectedTransportItem | undefined>(undefined);
  public readonly selectedTrackingItem = computed(() => this._selectTrackingItem());

  public setSelectedItem(item: SelectedTransportItem) {
    this._selectTrackingItem.set(item);
  }
}
